/* BUYLOOPS featured-pack panel. Generated — do not edit by hand. */
window.BL_PANEL_DATA = {"handle":"billboard-bundle","title":"Billboard","titleAccent":"Bundle","vendor":"WavWarehouse \u00d7 BUYLOOPS","desc":"10 quality sample packs with 100+ original compositions.","badge":"Bestseller","specs":["WAV","Stems","24 Bit","100% Original"],"main":{"url":"https://cdn.shopify.com/s/files/1/0755/9099/2139/files/bl-billboard-bundle-preview.mp3?v=1789596821","duration":120.0,"peaks":[0.08,0.71,0.48,0.84,0.96,0.64,0.56,0.25,0.84,0.68,0.14,0.14,0.87,0.57,0.1,0.08,0.57,0.93,0.48,0.93,0.97,0.97,0.66,0.61,0.3,0.91,0.79,0.17,0.16,0.9,0.86,0.1,0.12,0.33,0.84,0.15,0.95,0.61,0.95,0.75,0.45,0.24,0.91,0.87,0.16,0.15,0.12,0.92,0.12,0.09,0.61,0.91,0.27,0.33,0.83,0.64,0.7,0.61,0.63,0.59,0.52,0.5,0.51,0.49,0.91,0.63,0.57,0.53,0.82,0.55,0.48,0.59,0.84,0.52,0.69,0.71,0.56,0.6,0.78,0.65,0.46,0.45,0.48,0.45,0.83,0.59,0.63,0.55,0.71,0.6,0.55,0.63,0.83,0.6,0.77,0.62,0.61,0.69,0.79,0.63,0.62,0.51,0.42,0.3,0.88,0.88,0.9,0.82,0.85,0.9,0.86,0.87,0.27,0.95,0.88,0.87,0.87,0.89,0.8,0.86,0.73,0.92,0.7,0.8,0.89,0.76,0.92,0.95,0.89,0.94,0.93,0.97,0.81,0.91,0.92,0.69,0.9,0.63,0.91,0.99,0.87,0.97,0.82,0.87,0.73,0.81,0.83,0.56,0.96,0.83,0.9,0.73,0.56,0.31,0.95,0.7,0.66,0.71,0.78,0.76,0.69,0.82,0.85,0.66,0.62,0.57,0.61,0.7,0.73,0.72,0.71,0.59,0.56,0.63,0.69,0.69,0.62,0.85,0.8,0.63,0.93,0.69,0.86,0.78,0.94,0.75,0.9,0.64,0.58,0.61,0.77,0.78,0.72,0.83,0.87,0.63,0.65,0.6,0.7,0.67,0.6,0.62,0.51,0.31,0.96,0.93,0.66,0.95,0.5,0.76,0.95,0.54,0.44,0.66,0.6,0.86,0.91,0.72,0.5,0.85,0.53,0.71,0.69,0.49,0.44,0.68,0.72,0.88,0.88,0.71,0.52,0.97,0.39,0.52,0.48,0.48,0.4,0.73,0.72,0.64,0.8,0.6,0.51,0.94,0.46,0.57,0.73,0.73,0.45,0.78,0.67,0.67,0.67,0.41,0.99,0.76,0.77,0.68,0.83,0.82,0.78,0.63,0.61,0.57,0.58,0.63,0.86,0.82,0.88,1,0.79,0.91,0.62,0.63,0.66,0.72,0.68,0.55,0.7,0.94,0.7,0.65,0.57,0.84,0.85,0.77,0.93,0.96,0.95,0.59,0.61,0.73,0.88,0.77,0.64,0.63,0.4,0.3,0.18,0.09]},"tracks":[{"name":"Higher Places","tag":"Melody","realTitle":"Chronicles of '93","vendor":"Saint Luca","url":"https://osaria-system.eu/_audio_bucket_player/66e765-be.myshopify.com/8769382744331/tx5RG5OdmT0.mp3","artwork":"https://cdn.shopify.com/s/files/1/0755/9099/2139/files/Artwork_3e3c3482-a5df-46a4-a054-b63c9c499c64_400x.jpg?v=1723450729","duration":205.83},{"name":"Midnight Drive","tag":"Drums","realTitle":"Lavish Estate Vol. 1","vendor":"WAV Warehouse","url":"https://osaria-system.eu/_audio_bucket_player/66e765-be.myshopify.com/8816935141643/w1PsCbdksuE.mp3","artwork":"https://cdn.shopify.com/s/files/1/0755/9099/2139/files/Lavish_400x.jpg?v=1726433425","duration":206.76},{"name":"Velvet Keys","tag":"Melody","realTitle":"Lavish Estate Vol. 2","vendor":"WAV Warehouse","url":"https://osaria-system.eu/_audio_bucket_player/66e765-be.myshopify.com/8816937402635/wNorD5HxqFk.mp3","artwork":"https://cdn.shopify.com/s/files/1/0755/9099/2139/files/Artwork_5de9dfa6-5bb4-4f52-a6e5-2c28aa4f8bb0_400x.jpg?v=1726433907","duration":205.83},{"name":"No Limits","tag":"Full Beat","realTitle":"Levitation","vendor":"Saint Luca","url":"https://osaria-system.eu/_audio_bucket_player/66e765-be.myshopify.com/8816955621643/tCOvG7O0CRc.mp3","artwork":"https://cdn.shopify.com/s/files/1/0755/9099/2139/files/levitationArtwork_400x.png?v=1726436043","duration":205.83},{"name":"Ocean Thoughts","tag":"Melody","realTitle":"Rompiendo","vendor":"Saint Luca","url":"https://osaria-system.eu/_audio_bucket_player/66e765-be.myshopify.com/8816957817099/X3z0Ug5OmS4.mp3","artwork":"https://cdn.shopify.com/s/files/1/0755/9099/2139/files/rompiArtwork_1_400x.jpg?v=1726436390","duration":206.71},{"name":"Late Signal","tag":"Melody","realTitle":"Renaissance","vendor":"Saint Luca","url":"https://osaria-system.eu/_audio_bucket_player/66e765-be.myshopify.com/8816957161739/hPeiajPqt0w.mp3","artwork":"https://cdn.shopify.com/s/files/1/0755/9099/2139/files/renaArtwork_400x.png?v=1726436367","duration":205.88},{"name":"Paper Planes","tag":"Drums","realTitle":"Nebula","vendor":"TheSkyBeats","url":"https://osaria-system.eu/_audio_bucket_player/66e765-be.myshopify.com/8769333952779/azLCa2TbV3w.mp3","artwork":"https://cdn.shopify.com/s/files/1/0755/9099/2139/files/Artwork_400x.png?v=1723448016","duration":205.83},{"name":"Slow Burn","tag":"Melody","realTitle":"Crafted Classics Vol. 1","vendor":"WAV Warehouse","url":"https://osaria-system.eu/_audio_bucket_player/66e765-be.myshopify.com/8769365508363/Gc6XR9V-ms8.mp3","artwork":"https://cdn.shopify.com/s/files/1/0755/9099/2139/files/Artwork_39d005af-e13c-48dc-9ef7-76df3ffe3dd3_400x.jpg?v=1723449797","duration":205.83},{"name":"Crosstown","tag":"Full Beat","realTitle":"Soul Finders Vol. 1","vendor":"WAV Warehouse","url":"https://osaria-system.eu/_audio_bucket_player/66e765-be.myshopify.com/8816940024075/bZS5mc5Hxmk.mp3","artwork":"https://cdn.shopify.com/s/files/1/0755/9099/2139/files/soulArtwork_400x.png?v=1726434169","duration":296.28},{"name":"Afterglow","tag":"Melody","realTitle":"Phantom Harmonies Vol. 1","vendor":"WAV Warehouse","url":"https://osaria-system.eu/_audio_bucket_player/66e765-be.myshopify.com/8816938615051/iV2P3rk4A4Y.mp3","artwork":"https://cdn.shopify.com/s/files/1/0755/9099/2139/files/phantom_400x.jpg?v=1726434046","duration":225.88}]};

(function () {
  'use strict';

  var D = window.BL_PANEL_DATA;
  if (!D) return;

  var MOUNTED = 'blPanelMounted';

  function clock(s) {
    if (!isFinite(s) || s < 0) s = 0;
    return Math.floor(s / 60) + ':' + String(Math.floor(s % 60)).padStart(2, '0');
  }

  function el(html) {
    var t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstElementChild;
  }

  var seq = 0;

  // Build one featured-pack panel inside `host`.
  function build(host) {
    if (host.dataset[MOUNTED]) return;
    host.dataset[MOUNTED] = '1';

    var root = el(
      '<div class="bl-panel">' +
        '<div class="bl-panel-top">' +
          '<span class="bl-panel-eyebrow">Featured Pack</span>' +
          '<span class="bl-panel-badge"></span>' +
        '</div>' +
        '<h3 class="bl-panel-title"></h3>' +
        '<p class="bl-panel-desc"></p>' +
        '<div class="bl-panel-main"></div>' +
        '<div class="bl-panel-rows"></div>' +
        '<div class="bl-panel-specs"></div>' +
      '</div>'
    );
    host.appendChild(root);

    root.querySelector('.bl-panel-badge').textContent = D.badge || '';
    root.querySelector('.bl-panel-title').innerHTML =
      D.title + '<span class="r">' + D.titleAccent + '</span>';
    root.querySelector('.bl-panel-desc').textContent = D.desc || '';
    root.querySelector('.bl-panel-specs').innerHTML =
      (D.specs || []).map(function (s) { return '<span class="bl-spec">' + s + '</span>'; }).join('');

    /* ---- main waveform ---- */
    var mainSlot = root.querySelector('.bl-panel-main');
    mainSlot.classList.add('bl-slot');
    var node = document.createElement('div');
    var time = document.createElement('span');
    time.className = 'bl-time';
    time.textContent = '0:00 / ' + clock(D.main.duration);
    mainSlot.append(node, time);

    node.id = 'bl-panel-main-' + (++seq);
    node.setAttribute('data-waveform-player', '');
    node.setAttribute('data-audio-mode', 'external');
    node.setAttribute('data-url', D.main.url);

    if (window.WaveformPlayer) {
      new window.WaveformPlayer(node, {
        audioMode: 'external',
        singlePlay: true,
        url: D.main.url,
        peaks: D.main.peaks,
        waveformStyle: 'bars',
        barWidth: 2, barSpacing: 1, barRadius: 1,
        height: 48, samples: 150,
        showInfo: false, showTime: true, preload: 'none',
        title: D.title + ' ' + D.titleAccent,
        artist: D.vendor,
        waveformColor: '#C6CEDA',
        progressColor: '#EC1C24'
      });
    }

    var dur = D.main.duration || 0;
    node.addEventListener('waveformplayer:timeupdate', function (e) {
      var d = e.detail || {};
      if (d.duration) dur = d.duration;
      time.textContent = clock(d.currentTime || 0) + ' / ' + clock(dur);
    });

    /* ---- track rows ---- */
    var rowsEl = root.querySelector('.bl-panel-rows');
    (D.tracks || []).slice(0, 5).forEach(function (t, i) {
      var row = el(
        '<div class="bl-trow" title="' + t.realTitle + '">' +
          '<span class="bl-trow-play"><svg viewBox="0 0 24 24"><path d="M7 4l13 8-13 8z"/></svg></span>' +
          '<span class="bl-trow-num">' + String(i + 1).padStart(2, '0') + '</span>' +
          '<span class="bl-trow-name">' + t.name + '</span>' +
          '<span class="bl-trow-tag">' + t.tag + '</span>' +
          '<span class="bl-trow-dur">' + clock(t.duration) + '</span>' +
          '<span class="bl-trow-more">…</span>' +
        '</div>'
      );
      rowsEl.appendChild(row);
      row.addEventListener('click', function () {
        rowsEl.querySelectorAll('.bl-trow.on').forEach(function (r) { r.classList.remove('on'); });
        row.classList.add('on');
        if (window.WaveformBar && window.WaveformBar.play) {
          window.WaveformBar.play({
            url: t.url, title: t.name, artist: t.vendor,
            artwork: t.artwork, peaks: t.peaks
          });
        }
      });
    });
    if (rowsEl.firstElementChild) rowsEl.firstElementChild.classList.add('on');

    // GemPages wraps the hero in <form action="/cart/add">. A <button> with no
    // type defaults to type="submit", so clicking play submitted the form and
    // navigated to the product page instead of playing. Pin every button here.
    function pinButtonTypes() {
      var btns = root.querySelectorAll('button:not([type])');
      for (var i = 0; i < btns.length; i++) btns[i].type = 'button';
    }
    pinButtonTypes();
    // the player swaps its control markup on state changes, so re-pin after those
    ['waveformplayer:play', 'waveformplayer:pause', 'waveformplayer:ended']
      .forEach(function (ev) { node.addEventListener(ev, pinButtonTypes); });
  }

  var observer = null, queued = false;

  function stopWatching() {
    if (observer) { observer.disconnect(); observer = null; }
  }

  function scan() {
    queued = false;
    var hosts = document.querySelectorAll('[data-bl-panel]');
    for (var i = 0; i < hosts.length; i++) {
      if (!hosts[i].dataset[MOUNTED]) build(hosts[i]);
    }
    // One panel per page. Once it exists there is nothing left to watch for,
    // and a document-wide observer on a GemPages page is expensive.
    if (hosts.length) stopWatching();
  }

  // Coalesce bursts of mutations into a single scan on the next frame.
  function queueScan() {
    if (queued) return;
    queued = true;
    if (window.requestAnimationFrame) window.requestAnimationFrame(function () { scan(); });
    else setTimeout(scan, 16);
  }

  function init() {
    scan();

    if (window.WaveformBar && window.WaveformBar.init && !window.WaveformBar.isInitialized) {
      window.WaveformBar.init({ continuous: true, persist: true, showQueue: true, showVolume: true });
    }

    // GemPages renders sections lazily, so the marker may not exist yet.
    if (!document.querySelector('.bl-panel') && typeof MutationObserver !== 'undefined') {
      observer = new MutationObserver(queueScan);
      observer.observe(document.body, { childList: true, subtree: true });
      // Hard stop so we never watch the document indefinitely.
      setTimeout(stopWatching, 20000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
